import { Routes } from '@angular/router';

/**
 * Rotas que só existem no `ng serve` local. Este arquivo (vazio) é o usado em todos os builds,
 * inclusive homologação (`npm run build`) e produção; a configuração `local` do `angular.json`
 * troca por `dev.routes.local.ts`, que traz as páginas de desenvolvimento.
 */
export const DEV_ROUTES: Routes = [];
